import { Injectable } from '@angular/core';
import { ScriptLoaderService } from './script-loader.service';
import { Router } from "@angular/router";
declare let $: any;
@Injectable()
export class CommonService {

    constructor(private _script: ScriptLoaderService, private router: Router) { }

    getStatusClass(status) {
        let statusObj = {
            "active": {
                class: " m-badge--success"
            },
            "resolved": {
                class: " m-badge--success"
            },
            "success": {
                class: " m-badge--success"
            },
            "deactive": {
                class: " m-badge--danger"
            },
            "failed": {
                class: " m-badge--danger"
            },
            "pending": {
                class: " m-badge--warning"
            },
            "default": {
                class: " m-badge--secondary"
            }
        };
        let x = statusObj[status.toLowerCase()]
        x = x ? x : statusObj['default'];
        return x['class'];
    }

    loadDataTable(selector) {
        this._script.loadScripts(selector,
            ['assets/demo/default/custom/crud/metronic-datatable/base/custom-table.js']);
    }

    loadAdvanceDataTable(selector) {
        this._script.loadScripts(selector,
            ['assets/vendors/custom/datatables/datatables.bundle.js']);
    }


    loadTable(tableData, tableColumns, autoHide = false) {
        console.log('loadDataTable');

        let options: any = {

            search: {
                input: $("#generalSearch")
            }, data: {
                type: "local",
                source: tableData,
                pageSize: 10
            }, rows: {
                autoHide: autoHide
            }, columns: tableColumns
        }

        let datatable = $('.m-datatable').mDatatable(options);


    }

    loadBasicScrollableTable(id) {
        console.log('loadBasicScrollableTable');
        let options: any = {
            scrollY: "100vh",
            scrollX: !0,
            scrollCollapse: !0
        }
        jQuery(document).ready(function() {
            let datatable = (<any>$(id)).DataTable(options);
        });
    }

    destroyAdvanceDataTable(id) {
        console.log('destroyAdvanceDataTable');

        jQuery(document).ready(function() {
            var table = (<any>$(id)).dataTable({
                "bDestroy": true
            });
        });

    }

    destroyTable() {
        console.log('destroyTable');
        let datatable = $(".m-datatable").mDatatable("destroy");
    }

    reloadTable() {
        console.log('reloadTable');
        let datatable = $(".m-datatable").mDatatable("reload");
    }

    tbl_search(selector, columnName) {
        $(selector).on("change", function() {
            let datatable = $(".m-datatable").mDatatable();
            datatable.search($(this).val(), columnName)
        })
    }

    editEventOnDataTable(path) {
        let _self = this
        $('.m-datatable').hover((e) => {

            $('.btn-edit').click(function() {
                let id = $(this).attr('id');
                console.log('editEventOnDataTable =>', 'http://localhost:4200/' + path + id);

                _self.router.navigate([path + id])
            });
        });
    }

    eventOnDataTable(className, redirectPath) {
        $('.m-datatable').hover((e) => {
            let _self = this
            $(`.${className}`).click(function() {
                let id = $(this).attr('id');
                console.log('eventOnDataTable =>', 'http://localhost:4200/' + redirectPath + id);
                if ((<KeyboardEvent>window.event).ctrlKey) {
                    window.open(redirectPath + id);
                } else {
                    _self.router.navigate([redirectPath + id])
                }

            });
        });
    }

    eventRefOnDataTable(className, redirectPath) {
        $('.m-datatable').hover((e) => {
            let _self = this
            $(`.${className}`).click(function() {
                let id = $(this).attr('itemref');
                console.log('eventOnDataTable =>', 'http://localhost:4200/' + redirectPath + id);

                _self.router.navigate([redirectPath + id])
            });
        });
    }


    setSelectpicker() {
        let selectpicker = $(".m_selectpicker").selectpicker()
    }

    refreshSelectpicker() {
        setTimeout(() => {
            let selectpicker = $(".m_selectpicker").selectpicker('refresh')
        }, 0);
    }

    setdatetimepicker() {
        let datetimepicker = $(".m_datetimepicker").datetimepicker({
            todayHighlight: !0,
            autoclose: !0,
            format: "yyyy-mm-dd hh:ii:00"
        })
    }

    setdatepicker() {
        let datetimepicker = $(".m_datepicker").datepicker({
            todayHighlight: !0,
            orientation: "bottom left",
            format: "yyyy-mm-dd",
            templates: {
                leftArrow: '<i class="la la-angle-left"></i>',
                rightArrow: '<i class="la la-angle-right"></i>'
            }
        })
    }

    settimepicker() {
        let timepicker = $(".m_timepicker").timepicker({
            minuteStep: 1,
            // template: false,
            // showInputs: false,
            showSeconds: true,
            showMeridian: false,
            snapToStep: !0
        })
    }

    refreshDatePicker(selector, date) {
        if (date) {
            let firstOpen = true;
            let datetimepicker = $(selector)
                .datepicker().on('show', function(e) {
                    if (firstOpen == true) {
                        $(this).datepicker('setDate', date);
                        firstOpen = false;
                    }
                });
        }
    }

    refreshtimepicker(selector, time) {
        let firstOpen = true;
        let timepicker = $(".m_timepicker")
            .timepicker()
            .on('show.timepicker', function(e) {
                if (firstOpen == true) {
                    $(selector).timepicker('setTime', time);
                    firstOpen = false;
                }
            });
    }

    getFormattedDate(date) {
        if (date) {
            // console.log('DB DATE',date);
            date = this.minus530(date);
            // console.log('minus530',date);
            date = new Date(date ? date : '')
            // console.log('after',date);
            let year = date.getFullYear();
            let month = (1 + date.getMonth()).toString();
            month = month.length > 1 ? month : '0' + month;
            let day = date.getDate().toString();
            day = day.length > 1 ? day : '0' + day;
            return year + '-' + month + '-' + day;
        } else { return date; }
    }

    getSplitDate(date) {
        if (date) {
            date = date.split("T");
            return date[0];
        }
    }

    getFormattedDateChart(date) {
        date = new Date(date ? date : '')
        var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let day = date.getDate().toString();
        day = day.length > 1 ? day : '0' + day;
        return months[date.getMonth()] + '-' + day;
    }

    getFormattedTime(date) {
        let hr = date.getHours();
        let min = date.getMinutes();
        let sec = date.getSeconds();
        return hr + ':' + min + ':' + sec;
    }

    notify(message, type) {
        let options = {
            message: message
        };
        let settings = {
            type: type,
            animate: {
                enter: 'animated lightSpeedIn',
                exit: 'animated lightSpeedOut'
            },
            placement: {
                from: "bottom",
                align: "right"
            }
        }
        let notify = $.notify(options, settings);
    }

    addMintoDate(date) {
        let myTimeSpan = 330;
        let feedback_date = new Date(date);
        let dm = feedback_date.setMinutes(feedback_date.getMinutes() + myTimeSpan)
        return new Date(dm);
    }

    minus530(date) {
        date = new Date(date);
        let dm = date.setMinutes(date.getMinutes() - 330);
        return new Date(dm);
    }

    checkPassword() {

        $("input[type=password]").keyup(function() {
            var ucase = new RegExp("[A-Z]+");
            var lcase = new RegExp("[a-z]+");
            var num = new RegExp("[0-9]+");
            let disabled = true
            if ($("#password1").val().length >= 8) {
                $("#8char").removeClass("glyphicon-remove");
                $("#8char").addClass("glyphicon-ok");
                $("#8char").css("color", "#34bfa3");
                disabled = false
            } else {
                $("#8char").removeClass("glyphicon-ok");
                $("#8char").addClass("glyphicon-remove");
                $("#8char").css("color", "#FF0004");
                disabled = true
            }

            if (ucase.test($("#password1").val())) {
                $("#ucase").removeClass("glyphicon-remove");
                $("#ucase").addClass("glyphicon-ok");
                $("#ucase").css("color", "#34bfa3");
                disabled = false
            } else {
                $("#ucase").removeClass("glyphicon-ok");
                $("#ucase").addClass("glyphicon-remove");
                $("#ucase").css("color", "#FF0004");
                disabled = true
            }

            if (lcase.test($("#password1").val())) {
                $("#lcase").removeClass("glyphicon-remove");
                $("#lcase").addClass("glyphicon-ok");
                $("#lcase").css("color", "#34bfa3");
                disabled = false
            } else {
                $("#lcase").removeClass("glyphicon-ok");
                $("#lcase").addClass("glyphicon-remove");
                $("#lcase").css("color", "#FF0004");
                disabled = true
            }

            if (num.test($("#password1").val())) {
                $("#num").removeClass("glyphicon-remove");
                $("#num").addClass("glyphicon-ok");
                $("#num").css("color", "#34bfa3");
                disabled = false
            } else {
                $("#num").removeClass("glyphicon-ok");
                $("#num").addClass("glyphicon-remove");
                $("#num").css("color", "#FF0004");
                disabled = true
            }

            if ($("#password1").val() == $("#password2").val()) {
                $("#pwmatch").removeClass("glyphicon-remove");
                $("#pwmatch").addClass("glyphicon-ok");
                $("#pwmatch").css("color", "#34bfa3");
                disabled = false
            } else {
                $("#pwmatch").removeClass("glyphicon-ok");
                $("#pwmatch").addClass("glyphicon-remove");
                $("#pwmatch").css("color", "#FF0004");
                disabled = true
            }
            // console.log(disabled);

            $('#submitBtn').prop('disabled', disabled);
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/_services/common.service.ts